export type ResponsiveImageSources = {
  src: string;
  srcSet?: string;
};

export const HERO_IMAGE_WIDTHS = [480, 640, 960, 1280] as const;
export const PRODUCT_IMAGE_WIDTHS = [320, 480, 640, 960] as const;
export const BRAND_FEATURE_IMAGE_WIDTHS = [400, 640, 960, 1440] as const;

export function responsiveShopifyImageSources(
  source: string,
  widths: readonly number[],
  fallbackWidth: number,
): ResponsiveImageSources {
  try {
    const url = new URL(source);
    const host = url.hostname.toLowerCase();
    if (host !== "cdn.shopify.com" && !host.endsWith(".myshopify.com")) return { src: source };

    const candidates = [...new Set(widths.filter(width => Number.isFinite(width) && width > 0))]
      .sort((left, right) => left - right);
    if (!candidates.length) return { src: source };

    const withWidth = (width: number) => {
      const candidate = new URL(url);
      candidate.searchParams.set("width", String(width));
      candidate.searchParams.set("format", "webp");
      return candidate.toString();
    };
    return {
      src: withWidth(candidates.includes(fallbackWidth) ? fallbackWidth : candidates[candidates.length - 1]),
      srcSet: candidates.map(width => `${withWidth(width)} ${width}w`).join(", "),
    };
  } catch {
    return { src: source };
  }
}
